export default "__VITE_ASSET__C2Pl3DsI__"